import React from "react";
import DrawerContainer from "../containers/DrawerContainer";
import TextDropdown from "./TextDropdown";
import { Link } from "react-router-dom";

function HeaderComponent() {
  return (
    <>
      <header className="header">
        <div className="header__menu">
          <DrawerContainer />
          <Link className="header__brand" to="/">
            <img className="header__brandImage" src="/logo.png" alt="Logo" />
          </Link>
          <div className="header__separator"></div>
          <img
            className="header__ligaLabel"
            src="/liga_label.png"
            alt="label_liga"
          />
        </div>
        <div className="header__navigation">
          <ul className="header__navList">
            <li className="header__navItem">
              <img
                className="header__viviLaLigaEn"
                src="/vivi_la_liga.png"
                alt="vivi_la_liga"
              />
            </li>
            <li className="header__navItem">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/Liga-Regional-Futbol-Rio-Cuarto-103875364507797"
              >
                <img src="/facebook.png" alt="" />
              </a>
            </li>

            <li className="header__navItem">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/ligafutbolriocuarto/"
              >
                <img src="/instagram.png" alt="" />
              </a>
            </li>
          </ul>
        </div>
        <nav className="header__navBar">
          <ul className="header__navBarList">
            <a href="/" className="header__navBarListItem">
              Inicio
            </a>
            <a href="/torneos" className="header__navBarListItem">
              Torneos
            </a>
            <li className="header__navBarListItem">
              <TextDropdown
                title="Institucional"
                color="inherit"
                subitems={[
                  {
                    label: "Tribunal de disciplina",
                    to: "/tribunal-de-disciplina",
                  },
                  { label: "Trámites", to: "/tramites" },
                  { label: "Autoridades", to: "/autoridades" },
                ]}
              />
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
}

export default HeaderComponent;
